import { Autocomplete } from "common/component/Autocomplete";
import { highlight } from "common/component/Autocomplete";
import { Value } from "common/component/Autocomplete/types";
import { fromStyleLocals } from "common/css";
import { ContactDto, SearchCriteria } from "common/types/contact";
import { differenceBy, get, map, noop } from "lodash";

import * as stylesheet from "common/component/Autocomplete/Autocomplete.less";
const css = fromStyleLocals(stylesheet.locals);

export class ContactAutocomplete extends Autocomplete<
  ContactDto,
  SearchCriteria
> {
  protected getData(
    onSelect: (item: ContactDto) => void,
    exclude: ContactDto[],
    items: ContactDto[],
    criteria?: SearchCriteria
  ): Value[] {
    if (criteria === undefined) {
      return [];
    }

    const head: Value = {
      onclick: noop,
      properties: ["Contact name", "Contact company"],
      style: css("list-group-item", "header"),
    };

    const tail: Value[] = map(differenceBy(items, exclude, "id"), item => ({
      onclick: () => onSelect(item),
      properties: [
        highlight(
          criteria.name,
          get(item, "firstname", "") + " " + get(item, "lastname", "")
        ),
        highlight(criteria.clientcomm, get(item, "clientFull.name", "")),
      ],
      style: css("list-group-item"),
    }));

    return [head].concat(tail);
  }
}
